export const profileData = {
  githubName: "Emilprivate",
  githubRepo: "esd.mpw",
  githubOrg: "esd-homelab",
  SEO_Data: {
    title: "Emilprivate",
    description: "Emilprivate's personal website",
    url: "https://emilsd-web.org/",
    image: "https://emilsd-web.org/assets/images/profile-avatar.svg",
    keywords: ["Emilprivate", "GitHub", "Portfolio", "CV", "Projects", "Resume", "Blog", "Contact", "Social", "Games", "Software"],
  },
}